import { Components, Theme } from '@mui/material';

export const createPaperStyles = (theme: Theme): Components['MuiPaper'] => ({
  styleOverrides: {
    root: {
      backgroundColor: theme.palette.background.paper,
      backgroundImage: 'none',
    },
  },
});

export const createCardStyles = (theme: Theme): Components['MuiCard'] => ({
  styleOverrides: {
    root: {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      backgroundImage: 'none',
    },
  },
});

export const createRusticPaperStyles = (theme: Theme): Components['MuiPaper'] => ({
  styleOverrides: {
    root: {
      backgroundColor: '#fffaf2',
      backgroundImage: 'none',
    },
  },
});

export const createRusticCardStyles = (theme: Theme): Components['MuiCard'] => ({
  styleOverrides: {
    root: {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      backgroundImage: 'none',
    },
  },
});

export const createCardHeaderStyles = (theme: Theme): Components['MuiCardHeader'] => ({
  styleOverrides: {
    root: {
      backgroundColor: '#f9f2e7',
      borderBottom: '1px solid #d8c9b5',
    },
    title: {
      color: '#3a2d21',
    },
    subheader: {
      color: '#614e3b',
    },
  },
});

export const createCardContentStyles = (theme: Theme): Components['MuiCardContent'] => ({
  styleOverrides: {
    root: {
      backgroundColor: '#fffaf2',
      padding: '16px',
      '&:last-child': {
        paddingBottom: '16px',
      },
    },
  },
}); 